/* eslint-disable max-len */
import { defineComponent } from 'vue';
import SCardsSmall from '@core/slices/pages/cards-small/cards-small.vue';
import { Icon as CardsSmallIcon, Logo as CardsSmallLogo } from '@core/slices/pages/cards-small/mock.js';

export default defineComponent({
    name: 'SCardsSmall',
    components: {
        SCardsSmall,
    },
});

export const Figma = 'https://www.figma.com/design/SxYPthnMMnpIFdM8FAy3KT/01-2-UI-Kits---Website-UI?node-id=13361-9847&t=2XkN6La7v9gz0nyg-4';

export const Default = {
    args: {
        background: 'light-blue',
        useSmallTabs: false,
        title: 'Use Cases',
        slices: [{
            anchorId: 'one',
            name: 's-cards-small',
            data: CardsSmallIcon.args,
            label: 'System Builders',
        }, {
            name: 's-cards-small',
            data: CardsSmallLogo.args,
            label: 'HDD/SSD Vendors',
        }, {
            name: 's-cards-small',
            data: CardsSmallIcon.args,
            label: 'System Integrators',
        }, {
            name: 's-cards-small',
            data: CardsSmallLogo.args,
            label: 'Storage Vendors',
        }, {
            name: 's-cards-small',
            data: CardsSmallIcon.args,
            label: 'ISV/ Cloud Partners',
        }, {
            name: 's-cards-small',
            data: CardsSmallLogo.args,
            label: 'Custom Development',
        }, {
            name: 's-cards-small',
            data: CardsSmallIcon.args,
            label: 'Custom Development',
        }],
    },
};
